let api;
if(process.env.NODE_ENV === "production"){
    // api = "https://devbbh.tk/v1/"; //dev
    api = "https://api-cms.botup.io/v1/"; //production
} else {
    // api = "https://devbbh.tk/v1/";
    api = "https://api-cms.botup.io/v1/"; //production
}
export default api
